import { PropsWithChildren, FC } from 'react'
import { adminJobRequestQuery_jobRequest_parts_linesWithWorkOrderMapping as JobRequestLineType } from '@OpsQuality/JobRequestDetails/__generated__/adminJobRequestQuery'
import { getAngledImage } from '@OpsQuality/logic'

import Image from '~/core/Image'

import styles from './styles.css'

type ThumbnailImagePropsType = {
    jobRequestLine: JobRequestLineType
}

const ThumbnailImage: FC<
    PropsWithChildren<ThumbnailImagePropsType>
> = props => {
    const { jobRequestLine } = props

    if (!jobRequestLine) {
        return null
    }

    const thumbnail = getAngledImage(jobRequestLine) || ''

    return (
        <>
            <Image
                width="33px"
                height="33px"
                alt=""
                src={thumbnail}
                className={styles.thumbnailImageNoBorder}
            />
            {jobRequestLine?.name}
        </>
    )
}

export default ThumbnailImage
